import React from "react";
import "./App.css";
import Title from "./containers/Title";
import Game from "./containers/Game";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Start from "./containers/Start";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  const mainStyle = {
    width: "100%",
    height: "100%"
  };

  return (
    <Router>
      <Header />
      <div className="main" style={mainStyle}>
        <Route exact path="/" component={Title} />
        <Route exact path="/game" component={Game} />
        <Route exact path="/title" component={Title} />
        <Route exact path="/start" component={Start} />
      </div>
      <Footer />
    </Router>
  );
}

export default App;
